module.exports = __webpack_public_path__ + "static/careercafe-ac613944c25b983bb8c898e620467332.webp";